// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1EwYF","header":"PatientBlock_header__3mmz8","label":"PatientBlock_label__2Ga-k","option":"PatientBlock_option__1r_Js"};